import { render, staticRenderFns } from "./HeaderDownloadButton.vue?vue&type=template&id=4e7dad4c&scoped=true"
import script from "./HeaderDownloadButton.vue?vue&type=script&lang=ts"
export * from "./HeaderDownloadButton.vue?vue&type=script&lang=ts"
import style0 from "./HeaderDownloadButton.vue?vue&type=style&index=0&id=4e7dad4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7dad4c",
  null
  
)

export default component.exports